var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { clsx } from 'clsx';
var headingSizes = ['2xs', 'xs', 'sm', 'md', 'md2', 'lg', 'xl', '2xl', '3xl'];
var headingSizeStyles = {
    '2xs': 'text-2xs-head-m md:text-2xs-head-d',
    'xs': 'text-xs-head-m md:text-xs-head-d',
    'sm': 'text-sm-head-m md:text-sm-head-d',
    'md': 'text-md-head-m md:text-md-head-d',
    'md2': 'text-md2-head-m md:text-md2-head-d',
    'lg': 'text-lg-head-m md:text-lg-head-d',
    'xl': 'text-xl-head-m md:text-xl-head-d',
    '2xl': 'text-2xl-head-m md:text-2xl-head-d',
    '3xl': 'text-3xl-head-m md:text-3xl-head-d',
};
function Heading(_a) {
    var children = _a.children, size = _a.size, _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.tabbable, tabbable = _c === void 0 ? false : _c;
    var HeadingComponent;
    switch (size) {
        case '2xs':
            HeadingComponent = (_jsx("h6", __assign({ tabIndex: tabbable ? 0 : -1, className: clsx('text-2xs-head-m md:text-2xs-head-d font-display', className) }, { children: children })));
            break;
        case 'xs':
            HeadingComponent = (_jsx("h5", __assign({ tabIndex: tabbable ? 0 : -1, className: clsx('text-xs-head-m md:text-xs-head-d font-display', className) }, { children: children })));
            break;
        case 'sm':
            HeadingComponent = (_jsx("h4", __assign({ tabIndex: tabbable ? 0 : -1, className: clsx('text-sm-head-m md:text-sm-head-d font-display', className) }, { children: children })));
            break;
        case 'md':
            HeadingComponent = (_jsx("h3", __assign({ tabIndex: tabbable ? 0 : -1, className: clsx('text-md-head-m md:text-md-head-d font-display', className) }, { children: children })));
            break;
        case 'md2':
            HeadingComponent = (_jsx("h3", __assign({ tabIndex: tabbable ? 0 : -1, className: clsx('text-md2-head-m md:text-md2-head-d font-display', className) }, { children: children })));
            break;
        case 'lg':
            HeadingComponent = (_jsx("h2", __assign({ tabIndex: tabbable ? 0 : -1, className: clsx('text-lg-head-m md:text-lg-head-d font-display', className) }, { children: children })));
            break;
        case 'xl':
            HeadingComponent = (_jsx("h1", __assign({ tabIndex: tabbable ? 0 : -1, className: clsx('text-xl-head-m md:text-xl-head-d font-display', className) }, { children: children })));
            break;
        case '2xl':
            HeadingComponent = (_jsx("h1", __assign({ tabIndex: tabbable ? 0 : -1, className: clsx('text-2xl-head-m md:text-2xl-head-d font-display', className) }, { children: children })));
            break;
        case '3xl':
            HeadingComponent = (_jsx("h1", __assign({ tabIndex: tabbable ? 0 : -1, className: clsx('text-3xl-head-m md:text-3xl-head-d font-display', className) }, { children: children })));
            break;
        default:
            HeadingComponent = (_jsx("h1", __assign({ tabIndex: tabbable ? 0 : -1, className: clsx('text-xl-head-m md:text-xl-head-d font-display', className) }, { children: children })));
    }
    return HeadingComponent;
}
var HeadingTag = function (_a) {
    var _b = _a.as, Tag = _b === void 0 ? 'h1' : _b, _c = _a.size, size = _c === void 0 ? 'md' : _c, className = _a.className, children = _a.children;
    return _jsx(Tag, __assign({ className: clsx(headingSizeStyles[size], 'font-display', className) }, { children: children }));
};
export { Heading as default, HeadingTag };
